export const IOS_PRODUCT_ID = "game110";
export const ANDROID_PRODUCT_ID = "110";
export const COUNT_CARDS = 88;
// Этап 2: лимит названия индивидуальной (пустой) анкеты = самое длинное название
// карточки из наборов 88+57 (должен совпадать с BLANK_TITLE_MAX_LEN на бэке)
export const BLANK_FORM_TITLE_MAX = 60;
export const TEMPORARY_ID_KEY = "temporaryUserId";
export const ADULT_ALERT_WAS_SHOWN = "ADULT_ALERT_WAS_SHOWN";
export const COOKIE_CONSENT_KEY = "cookie_consent"; // значения: "accepted" | "rejected"
export const INSIGHT_INSTRUCTION_READ = "INSIGHT_INSTRUCTION_READ";
export const CURRENT_GAME_KEY = "currentGame";
export const CURRENT_USER_KEY = "currentUser";
export const CURRENT_TEMP_DEMO_GENDER = "CURRENT_TEMP_DEMO_GENDER";
export const copyText1 = "personal_acc.your_partner_invite";
export const copyText2 = "personal_acc.invite_link_desc";
export const copyText3 = "personal_acc.invite_link_desc2";
export const INSIGHT_FORM_STATUSES = {
  WANT_TO_IMPROVE: "WANT_TO_IMPROVE",
  REJECTED: "REJECTED",
  CAN_WATCH: "CAN_WATCH",
};

export const NOTIFY_MODAL_TYPES = {
  INVITE_PARTNER: "INVITE_PARTNER",
  NOTIFY_PARTNER: "NOTIFY_PARTNER",
};

// Этап 2: ключ localStorage для per-user реф-кода (?ref=) — ловится в App.js,
// подмешивается полем refCode при регистрации. Единый литерал против опечаток.
export const LOYALTY_REF_CODE_KEY = "wepurplay_ref";

// item 3: момент смены пола. Тексты карточек в БД гендерные (Questions.f_ru / m_ru —
// это ВЗАИМНО ОБРАТНЫЕ роли, а не перевод: «чтобы он сделал мне X» ↔ «сделать ей X»),
// а в Answers поля пола нет. Значит ответы, данные ДО смены пола, после неё читаются
// в зеркальном смысле, и предлагать их к переносу нельзя. Сравниваем с Answers.dateAnswer.
export const GENDER_CHANGED_AT_KEY = "wepurplay_gender_changed_at";
